import React from "react";
import { ReviewStatus } from "../types/review";

interface Props {
  status: ReviewStatus;
  stage: 1 | 2;
  cycleLabel?: string;
}

const ReviewHeader: React.FC<Props> = ({ status, stage, cycleLabel }) => {
  const pct = status.total > 0
    ? Math.round((status.reviewed / status.total) * 100)
    : 0;

  const displayLabel = cycleLabel ?? status.cycleName;

  return (
    <div style={{
      background: "#0078d4", color: "white",
      padding: "16px 24px", marginBottom: "24px", borderRadius: "4px",
      display: "flex", alignItems: "center", justifyContent: "space-between",
    }}>
      {/* Left: review info */}
      <div style={{ flex: 1 }}>
        <h2 style={{ margin: 0 }}>
          {status.toolName} — Access Review ({displayLabel})
          {stage === 2 && " · Stage 2 Escalation"}
        </h2>
        <div style={{ marginTop: "8px", fontSize: "14px", display: "flex", gap: "24px" }}>
          <span>Total members: <strong>{status.total}</strong></span>
          <span>Reviewed: <strong>{status.reviewed}</strong></span>
          <span>Pending: <strong>{status.pending}</strong></span>
          {stage === 1 && <span>Escalated: <strong>{status.escalated}</strong></span>}
        </div>
        {status.total > 0 && (
          <div style={{ marginTop: "10px", background: "rgba(255,255,255,0.3)", borderRadius: "4px", height: "6px" }}>
            <div style={{
              background: "white", height: "6px", borderRadius: "4px",
              width: `${pct}%`, transition: "width 0.3s ease",
            }} />
          </div>
        )}
      </div>

      {/* Right: trivago logo + IT Operations */}
      <div style={{
        display: "flex", flexDirection: "column", alignItems: "center",
        gap: "4px", marginLeft: "32px",
      }}>
        <img
          src="/trivago-logo.png"
          alt="trivago"
          style={{ height: "36px", width: "auto", objectFit: "contain" }}
        />
        <span style={{ fontSize: "11px", letterSpacing: "0.08em", opacity: 0.85, whiteSpace: "nowrap", color: "white" }}>
          IT Operations
        </span>
      </div>
    </div>
  );
};

export default ReviewHeader;
